import React, { Component } from 'react';
import RoutesContainer from './components/routes/RoutesContainer';

class App extends Component {
  render() {
    return <RoutesContainer />;
  }
}

export default App;
